import * as React from 'react'
import { useState } from 'react'
import { Collapse } from 'react-collapse'

import './popup.sass'

interface Props {
    children: React.ReactNode
    title?: string
    defaultOpen?: boolean
    isRed?: boolean
}

const FAQ: React.FunctionComponent<Props> = ({ children, title, defaultOpen = false, isRed = false }: Props) => {
    const [show, setShow] = useState(defaultOpen)

    return (
        <div className="faq">
            <div className={`faq-header${isRed ? ' faq-header-red' : ''}`} onClick={() => setShow(!show)}>
                <div>{title ? title : 'FAQ'}</div>
                <div className={show ? 'icon-faq show' : 'icon-faq'} />
            </div>
            <Collapse isOpened={show} theme={{ collapse: 'collapse', content: 'faq-content' }}>
                {children}
            </Collapse>
        </div>
    )
}

export default FAQ
